import React, { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import Sidebar from '../components/Sidebar'
import Header from '../components/Header'
import { HeartIcon, ChatAlt2Icon } from '@heroicons/react/outline'
import CountBadge from '../components/Content/Analytic/CountBadge'
import ExportButton from '../components/Content/Analytic/ExportButton'
import Conclution from '../components/Content/Analytic/Conclution'
import PieLabel from '../components/Content/Analytic/PieLabel'
import QuizChart from '../components/Content/Analytic/QuizChart'
import GradeChart from '../components/Content/Analytic/GradeChart'
import ScoreChart from '../components/Content/Analytic/ScoreChart'
import QuizModal from '../components/Content/QuizModal'
import { authenticated } from '../recoil/auth'
import { analyticData, analyticLoading, analyticMessage } from '../recoil/analytic'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import { domainWeb } from '../config/constants'
import axios from 'axios'
import WaitingText from '../components/WaitingText'
import { quizDetail } from '../recoil/quiz'

const ContentAnalyticPage = () => {
  const { contentId } = useParams();
  const auth = useRecoilValue(authenticated);
  const [loading, setLoading] = useRecoilState(analyticLoading);
  const [analytic, setAnalytic] = useRecoilState(analyticData);
  const setMessage = useSetRecoilState(analyticMessage);
  const [showQuizModal, setShowQuizModal] = useState(false);
  const setQuizSelected = useSetRecoilState(quizDetail);

  const middleLink = {
    label: "Konten",
    route: "/contents"
  };

  const clickQuiz = (quiz) => {
    setQuizSelected(quiz);
    setShowQuizModal(true);
  }

  const closeQuiz = () => {
    setQuizSelected({});
    setShowQuizModal(false);
  }

  const getAnalytics = useCallback(async () => {
    setLoading(true);
    setMessage({});
    setAnalytic({});
    try {
      let url = `${domainWeb}/contents/${contentId}/analytics`;
      let response = await axios.get(url,
        {headers: {
          'Content-Type': 'application/json', 
          'Accept': 'application/json', 
          'Authorization': 'Bearer ' + auth.token
        }}
      );
      setAnalytic(response.data);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  }, [auth.token, setLoading, setMessage, contentId, setAnalytic]);

  useEffect(() => {
    document.title = "Analisa Konten - Admin Hi Nano";
    getAnalytics();
  }, [getAnalytics]);

  const loadQuizChart = () => {
    if (loading || analytic.graph_data === undefined) {
        return <WaitingText/>;
    }
    if (analytic.graph_data.length === 0) {
        return <div>Tidak ada data.</div>;
    }
    return (
      <div>
        <QuizChart />
        <Conclution clickQuiz={clickQuiz} />
      </div>
    )
  };

  const loadGradeChart = () => {
    if (loading || analytic.grade_data === undefined) {
      return <WaitingText/>;
    }
    return (
      <div className="flex items-center gap-5">
        <GradeChart/>
        <PieLabel/>
      </div>
    )
  }

  const loadScoreChart = () => {
    if (loading || analytic.score_data === undefined) {
      return <WaitingText/>;
    }
    return <ScoreChart/>
  }
  

  return (
    <div className="flex min-h-screen bg-slate-100">
      
      <div className="flex-1 p-10 ml-28">
        <Header title="Analisa Konten" middle={middleLink} />
        <div className="flex items-center justify-between px-8 py-5 mb-6 bg-white rounded-lg shadow">
          <div className="w-1/2">
            <div className="text-sm">Judul Konten</div>
            <div className="text-xl font-semibold">{analytic.title}</div>
          </div>
          <div className="flex items-center gap-3">
            <CountBadge icon={HeartIcon} number={analytic.count_loves}/>
            <CountBadge icon={ChatAlt2Icon} number={analytic.count_comments}/>
            <ExportButton contentId={contentId}/>
          </div>
        </div>
        <div className="px-8 py-5 mb-6 bg-white rounded-lg shadow">
          <h3 className="mb-5 text-xl font-semibold">Grafik Analisa Kuis</h3>
          {loadQuizChart()}
        </div>
        <div className="px-8 py-5 mb-6 bg-white rounded-lg shadow">
          <h3 className="mb-3 text-xl font-semibold">Grafik Visualisasi Data Nilai</h3>
          <div className="flex gap-5">
            <div className="w-1/2">
              <h4 className="mb-2 text-slate-400">Jumlah Peserta Berdasarkan Kelompok Nilai</h4>
              {loadGradeChart()}
            </div>
            <div className="w-1/2">
              <h4 className="mb-2 text-slate-400">Jumlah Peserta Berdasarkan Nilai</h4>
              {loadScoreChart()}
            </div>
          </div>
        </div>
      </div>
      {
          showQuizModal ? (
              <QuizModal closeQuiz={closeQuiz} />
          ) : ("")
      }
      <Sidebar />
    </div>
  )
}

export default ContentAnalyticPage